export default class Throttleable {
  constructor(intervalDurationMs = 60) {
    this.running  = true;
    this.startTimer(intervalDurationMs);
  }

  nextTick() {}

  startTimer(interval) {
    if(this.running) {
      // use setTimeout instead of requestAnimationFrame because 
      // raq will not run in background tabs
      setTimeout(() => {
        this.nextTick();
        this.startTimer(interval);
      }, interval);
    }
  }
}


// WEBPACK FOOTER //
// ./src/Services/Behaviors/Throttleable.js